import { useAppContext } from '../context/AppContext';
import type { UILang } from '../context/AppContext';
import en from './en';
import de from './de';
import fr from './fr';
import it from './it';

const translations: Record<UILang, Record<string, string>> = { EN: en, DE: de, FR: fr, IT: it };

export function useT() {
  const { uiLang } = useAppContext();
  return (key: string, fallback?: string): string =>
    translations[uiLang]?.[key] ?? translations['EN']?.[key] ?? fallback ?? key;
}
